import styled from '@emotion/styled';

const SubTitle = styled('div')(({ theme }) => ({
  color: theme.colors.gray.medium,
  fontSize: '1.3rem',
  lineHeight: '1.15em',
}));

export default SubTitle;
